<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
    content-class="auth-error-dialog"
    overlay-opacity="0.99"
    :fullscreen="isMobile"
  >
    <v-card class="auth-error-card">
      <v-container class="pa-0">
        <v-card-title class="auth-error text-h6">
          {{ $t('validationText.error') }}
        </v-card-title>
        <v-card-text class="auth-error-text">
          <v-row>
            <v-col cols="12">
              <div>{{ $t('NotAuthorizedLocalizable') }}</div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="auth-error-actions">
          <v-btn
            color="secondary"
            @click="goToExternalUrl"
            data-testid="auth-error-dialog-close"
            >{{ $t('global.back') }}</v-btn
          >
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'vuex'
import { isMobile } from 'mobile-device-detect'

export default defineComponent({
  name: 'TokenAuthErrorDialog',
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    ...mapState('Security', ['isLoggedIn', 'isTokenAuthenticated']),
    externalCloudCases() {
      return this.isTokenAuthenticated
    },
    isMobile() {
      return isMobile
    },
  },
  methods: {
    showDialog() {
      if (this.externalCloudCases && !this.isLoggedIn) {
        this.dialog = true
      }
    },
    goToExternalUrl() {
      const externalUrl = localStorage.getItem('externalUrl')
      if (externalUrl) {
        window.location.href = externalUrl
      }
    },
  },
  watch: {
    isLoggedIn() {
      this.showDialog()
    },
  },
  mounted() {
    this.showDialog()
  },
})
</script>

<style lang="scss">
.auth-error-dialog {
  overflow: hidden;
}
</style>
